import axios, { AxiosInstance } from 'axios';

// Validate environment variable
const API_URL = process.env.REACT_APP_API_URL;
if (!API_URL) {
	// eslint-disable-next-line no-console
	console.error('REACT_APP_API_URL is not defined in environment variables');
}

// Create axios instance with default config
const api: AxiosInstance = axios.create({
	baseURL: API_URL,
	headers: {
		'Content-Type': 'application/json',
	},
});

// Add request interceptor for authentication and debugging
api.interceptors.request.use(
	(config) => {
		// Log the full URL being called
		// eslint-disable-next-line no-console
		console.log(
			'Making request to:',
			`${config.baseURL || ''}${config.url || ''}`,
		);

		if (config.skipAuthInterceptor) {
			return config;
		}

		const token = localStorage.getItem('access_token');
		if (token) {
			config.headers.Authentication = `Bearer ${token}`;
		}

		return config;
	},
	(error) => {
		return Promise.reject(error);
	},
);

// Add response interceptor for error handling
api.interceptors.response.use(
	(response) => response,
	(error) => {
		// Handle 401 Unauthorized responses
		if (error.response?.status === 401) {
			localStorage.removeItem('access_token');
			localStorage.removeItem('refresh_token');
			// Optionally redirect to login page
			window.location.href = '/signin';
		}
		return Promise.reject(error);
	},
);

// Export both the configured instance and a function to create new instances
export const createApi = (baseURL?: string): AxiosInstance => {
	return axios.create({
		baseURL: baseURL || API_URL,
		headers: {
			'Content-Type': 'application/json',
		},
	});
};

export default api;
